<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: '16px' }">
		<template #title>
			<h6 class="font-semibold m-0">{{$t('visitor-page.visitor-history-card.title')}}</h6>
		</template>
		<p v-if="appointments.length > 0" slot="extra" class="card-header-date">
			<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path class="fill-dark" fill-rule="evenodd" clip-rule="evenodd" d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z" fill="#111827"/>
			</svg>
			<span style="color: black !important;">{{ headerDate }}</span>
		</p>
		<a-list
            :loading="isLoading"
			class="transactions-list"
			item-layout="horizontal"
			:split="false"
			:data-source="appointments"
		>
        
			<a-list-item slot="renderItem" slot-scope="item">
				<template v-if="item.period">
					<h6>{{ item.period }}</h6>
				</template>
				<template v-else>
                    <appointment-history-item :item="item"/>
				</template>
			</a-list-item>
            <div
                slot="loadMore"
                :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
            >
                <a-spin v-if="hasMoreData && isLoadingMore" />
                        
                <a-button v-if="hasMoreData  && !isLoadingMore" type="primary" block size="small" @click="loadMore"> 
                    <svg v-show="true" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H3Z" fill="#111827"/>
                        <path d="M3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H10C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7H3Z" fill="#111827"/>
                        <path d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H3Z" fill="#111827"/>
                        <path d="M15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44771 13 8L13 13.5858L11.7071 12.2929C11.3166 11.9024 10.6834 11.9024 10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071L13.2929 16.7071C13.4804 16.8946 13.7348 17 14 17C14.2652 17 14.5196 16.8946 14.7071 16.7071L17.7071 13.7071C18.0976 13.3166 18.0976 12.6834 17.7071 12.2929C17.3166 11.9024 16.6834 11.9024 16.2929 12.2929L15 13.5858L15 8Z" fill="#111827"/>
                    </svg>
			        {{$t('visitor-page.visitor-history-card.load-more')}}
		        </a-button>
                <div v-if="!hasMoreData" class="text-primary" style="font-weight: 600;">
                   {{$t('visitor-page.visitor-history-card.no-more-history')}}
                </div>
            </div>
            
		</a-list>
	</a-card>

</template>

<script>

import AppointmentHistoryItem from './AppointmentHistoryItem.vue';

import { useVisitorAppointmentsStore } from '../../stores/visitor-appointments-store';
import { mapActions, mapState } from 'pinia';
import { DateHelpers } from '../../helpers/DateHelpers';

export default {
    components: {
        AppointmentHistoryItem
    },
    data() {
        return {
            page: 1,
            isLoading: false,
            hasMoreData: false,
            isLoadingMore: false,
        }
    },
    computed: {
        ...mapState(useVisitorAppointmentsStore, [ 'appointments' ]),
        headerDate() {
            if (this.appointments.length > 0) {
                return DateHelpers.formatToReadableDate(this.appointments[0].systemTime)
            }
            return '';
        }
    },
    methods: {
        ...mapActions(useVisitorAppointmentsStore, [ 'fetchAppointments' ]),
        fetch() {
            
            if (this.appointments.length > 0) {
                this.isLoadingMore = true;
                this.page++;
            } else
                this.isLoading = true;
                
            this.fetchAppointments({ page: this.page, size: 20, action: this.appointments.length > 0 ? 'append' : 'replace' }).then(res => {
                if (res.body.nextPageToken.length > 0) {
                    this.hasMoreData = true;
                } else {
                    this.hasMoreData = false;
                }
                this.nextPageToken = res.body.nextPageToken;
                this.isLoadingMore = false;
                this.isLoading = false;
            }).catch(error => {
                /* TODO: handle error */
                this.isLoadingMore = false;
                this.isLoading = false;
            });
        },
        loadMore() {
            this.fetch();
        }
    },
    mounted() {
        this.fetch();
    }
}

</script>